// src/config.js
export const API_BASE_URL = "https://AdvocateAPI.codelovertechnology.com";
//export const API_BASE_URL = "http://localhost:5272";
//export const API_BASE_URL = "https://advocateapi.dccrssorgi-govin-com-verify.org";